import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { PaginatedSearchlightResponse, SearchlightPageParams } from '../types'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export const getSearchlightResults = async (
  query: string,
  params?: SearchlightPageParams
): Promise<PaginatedSearchlightResponse> => {
  return await client.get<PaginatedSearchlightResponse>('/api/search-light/search', {
    params: {
      searchQuery: query,
      ...params,
    },
  })
}
